import Footer from "./Footer";
import Header from "./Header";

const Layout = ({ children, isFooter }) => {
  return (
    <>
      <Header />
      {children}
      {isFooter && <Footer />}
    </>
  );
};

export default Layout;
